import Picker from 'vanilla-picker';

window.Picker = Picker;
